











































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import { storeHasilPemeriksaanUsg } from "@/store/modules/HasilPemeriksaanUsgStore";
import HasilPemeriksaanUsgSvc from "@/services/HasilPemeriksaanUsg";
import UnitRuangPicker, {
  namaUnitPelayanan
} from "@/components/common/UnitRuangPicker.vue";

@Component({
  components: { UnitRuangPicker },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class HasilPemeriksaanUsgInputModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) editData: any;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  requiredRule = [v => !!v || "*Kolom ini harus diisi"];

  jenisUsgOpts = [
    { value: "obstetri", text: "Obstetri" },
    { value: "ginekologi", text: "Ginekologi" },
    { value: "abdomen", text: "Abdomen" },
    { value: "lain", text: "Lain-lain" }
  ];

  form_data = this.defaultForm();

  defaultForm() {
    const today = localISODate();
    return {
      tanggal_pemeriksaan: today,
      ruang_klinik: "",
      jenis_usg: null as string | null,
      dokter_id: null as number | null,
      hasil_pemeriksaan: "",
      kesimpulan: ""
    };
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  get listDokter() {
    return storeDokter.list;
  }

  get storeUser() {
    return userModule.user;
  }

  @Watch("value")
  onDialogOpen(val: boolean) {
    if (val) {
      if (this.editData) {
        this.hydrateFromEdit();
      } else {
        this.form_data = this.defaultForm();
        if ((this.storeUser?.profesi || "").toLowerCase() === "dokter") {
          this.form_data.dokter_id = this.storeUser.id;
        }
        this.isiRuangKlinikLogin();
      }
    }
  }

  async isiRuangKlinikLogin() {
    const nama = await namaUnitPelayanan(userModule.loginUnitId);
    if (!nama || !this.dialog || this.editData || this.form_data.ruang_klinik) {
      return;
    }
    this.form_data.ruang_klinik = nama;
  }

  hydrateFromEdit() {
    const d = this.editData || {};
    this.form_data = {
      tanggal_pemeriksaan: d.tanggal_pemeriksaan || localISODate(),
      ruang_klinik: d.ruang_klinik || "",
      jenis_usg: d.jenis_usg || null,
      dokter_id: d.dokter?.id || null,
      hasil_pemeriksaan: d.hasil_pemeriksaan || "",
      kesimpulan: d.kesimpulan || ""
    };
  }

  buildPayload() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      tanggal_pemeriksaan: this.form_data.tanggal_pemeriksaan || null,
      ruang_klinik: this.form_data.ruang_klinik || null,
      jenis_usg: this.form_data.jenis_usg || null,
      dokter_id: this.form_data.dokter_id,
      hasil_pemeriksaan: this.form_data.hasil_pemeriksaan || null,
      kesimpulan: this.form_data.kesimpulan || null
    };
  }

  async save() {
    if (this.readOnly) return;
    const form = this.$refs.form as any;
    if (!form.validate()) return;

    if (this.saving) return;
    this.saving = true;

    try {
      const payload = this.buildPayload();
      const resp = this.editData
        ? await HasilPemeriksaanUsgSvc.update(this.editData.id, payload)
        : await HasilPemeriksaanUsgSvc.create(payload);

      if (resp.data.status == "1") {
        await storeHasilPemeriksaanUsg.getByRegister(this.register);
        this.dialog = false;
        this.$emit("saved", resp.data.data);
      }
    } finally {
      this.saving = false;
    }
  }

  close() {
    this.dialog = false;
  }
}
